import { Heading4, Icon, PageLink, Paragraph } from "shared/components";

import styles from "./LeftBlock.module.scss";

export const LeftBlock = ({ ...payload }) => {
  const title = payload?.leftTitle ?? "";
  const description = payload?.leftDescription ?? "";
  const buttonText = payload?.leftButton?.buttonText ?? "";
  const slug = payload?.leftButton?.page?.slug ?? "";

  return (
    <div className={styles.wrapper}>
      <Heading4 color="light" className={styles.title}>
        {title}
      </Heading4>
      <Paragraph color="light" className={styles.description}>
        {description}
      </Paragraph>
      <PageLink className={styles.button} slug={slug}>
        <Paragraph color="light" appearance="bigger">
          {buttonText}
        </Paragraph>
        <Icon className={styles.icon} name="arrow_right" />
      </PageLink>
    </div>
  );
};

export default LeftBlock;
